import { Button, Checkbox, Input, message, Radio } from "antd";
import React, { useEffect, useState } from "react";
import { ReactComponent as GolfIcon } from "icons/m2c-golf.svg";
import { ReactComponent as AnalyticsIcon } from "icons/analytics-project.svg";
import { ReactComponent as SimulationIcon } from "icons/simulationProject.svg";
import { ReactComponent as LaunchIcon } from "icons/m2c-launch.svg";
import { ReactComponent as AthelticsIcon } from "icons/athleticsLogo.svg";
import { ReactComponent as SelectedIcon } from "icons/selectedProject.svg";
import { UseLazyApiCallV2 } from "hooks/use-lazy-api-call-v2";
import { useCurrentUserContext } from "providers";
import styles from "./styles.module.scss";
import { AdminIcon } from "icons/adminIcon";
import { UserIcon } from "icons/user-icon";
import { allProjects, allProjectsSandbox } from "pages/settings/constants";
import { ENVIORNMENTS, getCurrentEnviornment } from "utils/constants";
import { ChangePasswordIcon, LiveIcon, SandboxIcon } from "icons";
import { ConditionalRenderer } from "components/conditonal-renderer";

export function AddUser({ refetch, setIsModalVisible }: any) {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [nameError, setNameError] = useState("");
  const [userRole, setUserRole] = useState("null");
  const [isPGUser, setIsPGUser] = useState(false);
  const [enviornment, setEnviornment] = useState<any>(null);

  const [selectedProjects, setSelectedProjects] = useState<any>([]);
  const [isButtonEnabled, setIsButtonEnabled] = useState(false);
  const [name, setName] = useState("");

  const { user } = useCurrentUserContext();

  const [addUser] = UseLazyApiCallV2({
    url: null,
    method: "POST",
  }) as any;

  const projects =
    getCurrentEnviornment() === ENVIORNMENTS.LIVE
      ? allProjects
      : allProjectsSandbox;

  const handleNameChange = (e: any) => {
    const value = e.target.value;
    setName(value);
  };
  const handleEmailChange = (e: any) => {
    const value = e.target.value;
    setEmail(value);

    // Validate email format
    if (value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      setEmailError("Invalid email format");
    } else {
      setEmailError("");
    }
  };

  const validateForm = () => {
    const isNameValid = name.trim() !== "";

    // Check if email is valid
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    // Check if at least one project is selected
    const isProjectSelected = selectedProjects.length > 0;

    // Enable button if email is valid and at least one project is selected
    setIsButtonEnabled(isNameValid && isEmailValid && isProjectSelected);
  };

  const handleProjectSelection = (project: any) => {
    if (selectedProjects.includes(project)) {
      setSelectedProjects(selectedProjects.filter((p: any) => p !== project));
    } else {
      setSelectedProjects([...selectedProjects, project]);
    }
  };

  const handleAddUser = async () => {
    const params = {
      name: name,
      email: email,
      role: userRole,
      projects: selectedProjects,
      loggedUser: user?.email,
      isPGUser,
    };

    try {
      const res = await addUser({
        url: "/create_user",
        params,
      });

      if (res?.status === "Success") {
        message.success(res?.message);
        refetch();
        setIsModalVisible(false);
      } else {
        message.error(res?.message);
      }
    } catch (error) {}
  };

  useEffect(() => {
    validateForm();
  }, [name, email, selectedProjects]);

  console.log({ isPGUser });

  return (
    <div className={styles.mainContainer}>
      <div className={styles.email}>Name</div>
      <Input
        className={styles.emailInput}
        placeholder="Enter Name"
        value={name}
        onChange={handleNameChange}
        allowClear
      />
      {nameError && <div className={styles.error}>{nameError}</div>}

      <div className={styles.email}>Email Address</div>
      <Input
        className={styles.emailInput}
        placeholder="Enter email address"
        value={email}
        onChange={handleEmailChange}
        allowClear
      />
      {emailError && <div className={styles.error}>{emailError}</div>}

      <div style={{ display: "flex", gap: "10px" }}>
        <div
          className={`${styles.admin} ${
            userRole === "admin" ? styles.active : ""
          }`}
          onClick={() => {
            setUserRole("admin");
            setSelectedProjects(projects);
          }}
        >
          <AdminIcon active={!!(userRole === "admin")} />
          Admin
        </div>
        <div
          className={`${styles.admin} ${
            userRole === "user" ? styles.active : ""
          }`}
          onClick={() => {
            setUserRole("user");
            setSelectedProjects([]);
          }}
        >
          <UserIcon active={!!(userRole === "user")} />
          User
        </div>
      </div>

      <div className={styles.server}>Select Project</div>
      <ConditionalRenderer
        condition={getCurrentEnviornment() === ENVIORNMENTS.LIVE}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: "20px",
          }}
        >
          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Golf")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Golf")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Golf") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <GolfIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Golf</div>
          </div>
          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Launch")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Launch")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Launch") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <LaunchIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Launch</div>
          </div>

          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Athletics")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Athletics")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Athletics") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <AthelticsIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Athletics</div>
          </div>

          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Simulation")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Simulation")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Simulation") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <SimulationIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Baseball</div>
          </div>

          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Analytics")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Analytics")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Analytics") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <AnalyticsIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Analytics</div>
          </div>
        </div>
      </ConditionalRenderer>
      <ConditionalRenderer
        condition={getCurrentEnviornment() === ENVIORNMENTS.SANDBOX}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            paddingBottom: "20px",
            gap: "20px",
          }}
        >
          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Golf")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Golf")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Golf") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <GolfIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Golf</div>
          </div>
          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Launch")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Launch")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Launch") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <LaunchIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Launch</div>
          </div>

          <div
            className={`${styles.serverContainer} ${
              selectedProjects.includes("Motion2Coach Analytics")
                ? styles.selected
                : ""
            }`}
            onClick={() => handleProjectSelection("Motion2Coach Analytics")}
          >
            <div
              style={{
                height: "30px",
                display: "flex",
                alignSelf: "end",
                padding: "1px",
              }}
            >
              {selectedProjects.includes("Motion2Coach Analytics") ? (
                <SelectedIcon />
              ) : (
                ""
              )}
            </div>
            <div style={{ width: "58px", height: "46px" }}>
              <AnalyticsIcon style={{ width: "100%", height: "100%" }} />
            </div>
            <div className={styles.serverTitle}>Motion2Coach Analytics</div>
          </div>
        </div>
      </ConditionalRenderer>

      <label
        htmlFor="pg-user"
        className={styles.server}
        style={{
          margin: 0,
          fontSize: "14px",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        <Checkbox
          id="pg-user"
          onChange={(event) => setIsPGUser((prev) => !prev)}
          checked={isPGUser}
        />
        Is Performance Golf User
      </label>

      <div
        style={{
          marginTop: "10px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Button
          className={styles.addButton}
          onClick={handleAddUser}
          disabled={!isButtonEnabled}
        >
          Add User{" "}
        </Button>
      </div>
    </div>
  );
}
